import {JobEmailSentEventDataApiDto, JobEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {option, Option} from "ts-option";
import JobEvent, {JobEmailEventSubtypeEnum, JobEventTypeEnum} from "./JobEvent";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import {getIndividualContact} from "../../../store/view/contact";
import {store} from "../../../navigation/ReduxProvider";
import moment = require("moment");

export default class JobEmailSentEvent extends JobEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber job reference number.
	 * @param data email send event data
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobEmailSentEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobEmailSentEvent {
		const data = JobEmailSentEventData.fromJson(json.data as JobEmailSentEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobEmailSentEvent(json.id,
			json.jobId,
			JobEventTypeEnum.JobEmailSent,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.New;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getActivityAdditionalMessages(): string[] {
		let actions: string[] = [];
		if (this.data.subject && !!this.data.subject.length) {
			actions.push(`Subject: ${this.data.subject}`);
		}

		return actions;
	}

	getActivityType(): string {
		return `E-MAIL`
	}

	getActivityMessage(): string {
		let eventMessage: string;
		switch (this.data.subtype) {
			case JobEmailEventSubtypeEnum.JobFreeTextContactEmail:
				eventMessage = "E-mail to contact";
				break;
			default:
				eventMessage = "E-mail to unknown receiver";
		}
		const receiver = this.data.receiverId.flatMap(r => getIndividualContact(r, store.getState()));
		const receiverName = receiver.isDefined ? ` - ${receiver.get.data.displayName()}` : "";
		const receiverMails =
			` (${this.data.receiverEmails.length ? this.data.receiverEmails.join(", ")
				: "unknown"})`;
		return eventMessage + receiverName + receiverMails;
	}
}

export class JobEmailSentEventData {
	constructor(public readonly receiverId: Option<string>,
		public readonly receiverEmails: string[],
		public readonly subject: string,
		public readonly message: string,
		public readonly subtype: string) {}

	public static fromJson(json: JobEmailSentEventDataApiDto): JobEmailSentEventData {
		return new JobEmailSentEventData(option(json.receiverId), json.receiverEmails, json.subject, json.message, json.subtype);
	}
}
